/**
 * 	1、导入 import scoketConnect from '@/utils/scoketConnect'
 * 	2、在destroyed中清理webscoket连接{
  		this.scoketConnect.clearSend();
  		this.scoketConnect.closeConnect();
	3、连接webscoket 如果已经连接webscoket 则更换pointId即可
		if(this.scoketConnect){
			this.scoketConnect.connect(pointIds);
		}else{
			@params obj 
				@params stompUrl 发送参数的链接 
				@params pointIds（require）  传递的数据对象  具体看后端需求  
				@params dataName 默认'dataId'   例如  'originList':this.pointId 则此dataName:'originList'
				@params pushType 默认1 查应用数据 6:称重系统
			@params callback  websocket链接回调函数
			this.scoketConnect = new scoketConnect({pointIds:pointIds},callback)
		}
	4、接收推送数据  初始化时传递的dataName，默认使用'realData'
		this.$Bus.$on(dataName,(data)=>{})
	5、具体用法可参考settlementMonitor
 */
import SockJS from "@/utils/scoketjs"
import "@/utils/stomp.min"
import { wsInstance} from "@/utils/common"
import {getToken} from './auth.js'
import Bus from '@/utils/bus'

class scoketConnect {
    constructor(obj,callback){
      this.token = getToken();
    	this.user =obj.user||this.token;
      let paramStr = "?token="+this.token;
    	this.connectUrl = obj.connectUrl?(wsInstance+obj.connectUrl)+paramStr: wsInstance+"/IOT-SERVER-WS/devicesocket/device"+paramStr
    	this.stompUrl = obj.stompUrl||"/listenOrigin"
    	this.receiveUrl = obj.receiveUrl||'/devicesocket/device/message/'+new Date().getTime()
      this.dataName = obj.dataName||'dataId'
    	this.realDataName = obj.realDataName||'realData'
      this.pointIds = obj.pointIds||[];
      this.pushType = obj.pushType==undefined?1:obj.pushType
      this.projectId = obj.projectId||''
      this.connectCallback = callback
		
    	this.websock = null
      this.reConnectCount = 0//重连次数超过3，就不再重连
      this.subscription  = null
      this.stompClient = null

      this.pushTypeList = [];// 针对单个页面发起多个send时的数据回调
      
      this.connect(this.pointIds)
    }
    clearSend(pushType){
		if( this.websock){
			let info = {
				user:this.user,
				pushType:pushType||this.pushType,
				projectId:this.projectId,
				type:'-1'
			}
			if(this.dataName == 'dataId'){
				info[this.dataName] = this.oldPointIds.toString();
			}else{
				info[this.dataName] = this.oldPointIds
			}
			this.send(info);
		}
	}
    sendByInfo(info){
    	let obj = {
			user:this.user,
			pushType:this.pushType,
			projectId:this.projectId
		}
    	this.send({...obj,...info})
    }
	closeConnect(){
    if(this.stompClient){
      this.stompClient.disconnect();
      this.websock.close();
      this.stompClient = null;
      this.websock = null;
    }
	}
	send(sendData) {
	    //发送消息的路径
      let uuidStr = this.receiveUrl.split('/')
      // 此处user为唯一表示与订阅最后一截 保持一致
      sendData.user = uuidStr[uuidStr.length-1]

		  this.pushTypeList.push(sendData.pushType)
	    this.stompClient&&this.stompClient.send(this.stompUrl,{},JSON.stringify(sendData));
	}
	//发送不同类型的链接,请求时不取消上次的请求，如需干掉上次的请求，可使用connect
	connectForType(pushType,pointIds){
		this.pointIds = pointIds||this.pointIds||[];
		let info = {
			user:this.user,
			pushType:pushType||this.pushType,
			projectId:this.projectId,
			type:'1'
		}
		if(this.dataName == 'dataId'){
			info[this.dataName] = this.pointIds.toString();
		}else{
			info[this.dataName] = this.pointIds
		}
		this.send(info);
	}
	/**
	 * 地址+端点路径，构建websocket链接地址
	 */
	connect(pointIds,pushType) {
		this.oldPointIds = JSON.parse(JSON.stringify(this.pointIds))
		this.pointIds = pointIds||[];
		this.pushType = pushType||this.pushType
		let info = {
			user:this.user,
			pushType:this.pushType,
			projectId:this.projectId,
			type:'1'
		}
		if(this.dataName == 'dataId'){
			info[this.dataName] = this.pointIds.toString();
		}else{
			info[this.dataName] = this.pointIds
		}
		if(this.websock){
			this.clearSend()
    		this.send(info);
		}else{
		    this.websock = new SockJS(this.connectUrl);
		    this.stompClient  = Stomp.over(this.websock);
		    // this.stompClient.debug = null ;//关闭调试
		    this.stompClient.connect({'Authorization':this.token}, (frame) =>{
	    		this.send(info);
	    		this.connectCallback&&this.connectCallback();
		        this.subscription&&this.subscription.unsubscribe();
		        this.subscription = this.stompClient.subscribe(this.receiveUrl, (response) =>{
		        	let obj ={};
		        	try{
		        		obj = JSON.parse(response.body);
		        		if(this.pushTypeList.includes(obj.pushType)||this.pushType == 'notype'){
		        			Bus.$emit(this.realDataName,obj)
		        		}
		        	}catch(e){
		        		console.log('deviceMonitor='+e)
		        	}
		        });
		      },
		      (error)=> {
		        // 连接失败时（服务器响应 ERROR 帧）的回调方法
            this.clearSend(this.pushType) 
            this.closeConnect()
            console.log("========链接失败重连",this.reConnectCount)
            if(this.reConnectCount<3){
              this.reConnectCount+=1;
              this.connect();
            }
		        console.log('连接失败【' + error + '】');
		    });
	    }
	}
}
export default scoketConnect